import React from 'react';
import { Button } from './button';
import Icon from './icon';

interface QuickAction {
  id: string;
  label: string;
  icon: string;
  action: string;
}

interface WelcomeScreenProps {
  userName: string;
  outletName: string;
  onVoiceRecord: () => void;
  onQuickAction: (action: any) => void;
  quickActions: readonly QuickAction[];
}

export const ChatWelcomeScreen: React.FC<WelcomeScreenProps> = ({
  userName,
  outletName,
  onVoiceRecord,
  onQuickAction,
  quickActions
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 min-h-full">
      {/* Welcome Message */}
      <div className="text-center mb-10">
        <div className="text-3xl font-bold mb-3 flex items-center justify-center gap-3">
          Xin chào {userName}
          <span
            className="text-lg inline-block cursor-pointer hover:scale-110 transition-transform duration-200"
            style={{ animation: 'wave 2s ease-in-out infinite' }}
          >
            👋
          </span>
        </div>
        <p className="text-xl text-muted-foreground">
          {outletName}
        </p>
      </div>

      {/* Microphone Button */}
      <div className="mb-8 flex flex-col items-center">
        <p className="text-lg text-muted-foreground mb-8 text-center">
          Bấm micro để bắt đầu trò chuyện nhé!
        </p>

        <Button
          onClick={onVoiceRecord}
          className="w-24 h-24 rounded-full shadow-lg transition-all duration-300 hover:scale-105 bg-blue-500 hover:bg-blue-600"
        >
          <Icon name="mic" size={36} className="text-white" />
        </Button>
      </div>

      {/* Quick Actions */}
      <div className="w-full text-center">
        <p className="text-lg text-muted-foreground mb-4 text-center">
          hoặc chọn một yêu cầu bên dưới
        </p>
        <div className="space-x-4 space-y-4 justify-center w-full">
          {quickActions.map((action) => (
            <Button
              key={action.id}
              variant="secondary"
              onClick={() => onQuickAction(action)}
              className="justify-start h-12 px-4"
            >
              <Icon name={action.icon} size={20} className="mr-2" />
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
